<template>
  <tab-container tabName="Create Chat Room" :isTabOpened="isTabOpen"  @toggleTab="(toOpen)=>{toggleTab(toOpen)}" class="z-30">
    
     <main>

      <section class="space-y-4 max-w-md mx-auto">

        <div v-for="(room,key) in newChatRoom" :key="key" class="space-y-1">
          <div v-if="room.type === 'icon'" @click="toggleIconTab(true)" class="bg-purple-600 rounded-full text-white w-28 h-28 mx-auto flex flex-col text-center pop-click overflow-hidden justify-between ring-4" :class="[{ 'ring-purple-700' :  room.isValidated },'ring-red-700']">
            <div v-if="!room.value" class="flex h-full">
              <ion-icon  class="text-5xl m-auto" name="images"></ion-icon>
            </div>
            <div v-else class="flex h-full">
              <img :src="room.value" alt="selected icon">
            </div>
            <div v-if="!room.value" class="bg-purple-500 flex py-2">
              <h6 class="text-xs capitalize m-auto leading-3">Pick <br/> chat icon</h6>
            </div>

          </div>

          <div v-if="!noLabelInputType.includes(room.type)"   class="flex justify-between text-xs font-bold">
            <label :class="[{ 'text-purple-700' : room.isValidated },'text-red-700']" :for="key">{{room.label}}</label>
            <h6 :class="[{ 'text-purple-700' :  room.isValidated },'text-red-700']" > {{ room.value.length + '/' + room.maxLength }}</h6>
          </div>
          
          <input v-if="room.type === 'text' " v-model="room.value" :type="room.type" :id="key" :placeholder="room.placeholder" class="text-input-default" autocomplete="off" :maxlength="room.maxLength" :class="[{ 'border-purple-700' :  room.isValidated },'border-red-700']" >

          <textarea v-if="room.type === 'textarea'" v-model="room.value" :type="room.type" :id="key" :placeholder="room.placeholder" class="text-input-default h-32" autocomplete="off" :maxlength="room.maxLength" :class="[{ 'border-purple-700' :  room.isValidated },'border-red-700']" ></textarea>

          <h6 v-if="!room.isValidated" class="text-red-600 text-xs font-bold">{{room.errorMessage}}</h6>
        </div>

        <div class="mt-5 w-full">
          <h4 @click="createNewChatRoom" class="btn-default" >Create Chat Room</h4>
        </div>

      </section>
     
    </main>

  </tab-container>
   
  <tab-container :willCheckScroll="true" tabName="Icon Selection" :isTabOpened="isIconTabOpened"  @toggleTab="(toOpen)=>{toggleIconTab(toOpen)}" class="z-40" @bottomScrolled="$refs.iconSelection.generateSeedIcon()" >
    <icon-selection ref="iconSelection" :currentSelectedIcon="newChatRoom.icon.value" @setNewIcon="(icon)=>{setNewIcon(icon)}" :isForChatRoom="true" ></icon-selection>
  </tab-container>

</template>

<script>
import firebase from "firebase/app";

import IconSelection from '@/components/IconSelection.vue';
import TabContainer from '@/components/TabContainer.vue';


export default {
  data () {
    return {
      isIconTabOpened : false,
      isCreatingChatRoom : false,
      noLabelInputType : ['icon','hidden'],
      newChatRoom : {
        
      },
      isTabOpen : false
    }
  },
  emits : ['notification'],
  mounted(){
    this.setDefaultChatRoomForm();
  },
  props : {
    creatorId : {
      type : String,
      required: true
    },
    costumizedUsersData : Object 
  },
  components : {
    'icon-selection' : IconSelection,
    'tab-container' : TabContainer
  },  
  computed : {
    
    chatRoomNameValue () {
      if(!this.newChatRoom.name)return '';
      return this.newChatRoom.name.value;
    },
    chatRoomIconValue () {
      if(!this.newChatRoom.icon)return '';
      return this.newChatRoom.icon.value;
    },
  },
  methods : {
    
    toggleIconTab(toOpen = null){
      if(toOpen === null)toOpen = !this.isIconTabOpened;
      this.isIconTabOpened = toOpen;
    },
    setDefaultChatRoomForm(){
      this.newChatRoom = {
        creatorId: {
          value : this.creatorId,
          type : "hidden",
        },
        membersId : {
          value : this.creatorId,
          type : "hidden",
        },
        icon : {
          value : '',
          type : "icon",
          label : "Icon",
          isRequired : true,
          errorMessage : "",
          isValidated : true
        },
        name : {
          value : '',
          type : "text",
          maxLength : 100,
          isRequired : true,
          label : "Name",
          placeholder : "Enter chat room name",
          errorMessage : "",
          isValidated : true
        },
        description : {
          value : '',
          type : "textarea",
          maxLength : 200,
          isRequired : false,
          label : "Description",
          placeholder : "Enter what this chat room all about",
          errorMessage : "",
          isValidated : true
        },
      }
    },
    toggleTab(toOpen = null){
      if(toOpen === null)return this.isTabOpen = !this.isTabOpen;
      this.isTabOpen = toOpen;
    },
    setNewIcon(icon){
      this.newChatRoom.icon.value = icon;
      this.isIconTabOpened = false;
    },
    validateNewChatRoom(key){
      const roomInput = this.newChatRoom[key];
      roomInput.errorMessage = "";
      if(roomInput.isRequired && roomInput.value.length <= 0)roomInput.errorMessage = "Chat room's " + roomInput.label.toLowerCase() + " is REQUIRED."
      const isValidated = roomInput.errorMessage.length === 0;
      return roomInput.isValidated = isValidated;
    },
    createNewChatRoom(){
      if(this.isCreatingChatRoom)return;
      let isAllInputValidated = true;
      for(let key in this.newChatRoom){
        let isCurrentInputValidated = this.validateNewChatRoom(key);
        if(isAllInputValidated)isAllInputValidated = isCurrentInputValidated;
      }
      if(!isAllInputValidated)return;
      this.isCreatingChatRoom = true;

      const createDate =  Date.now();
      const createRoomMessage = {
        date : createDate,
        message : this.costumizedUsersData.username + ' created the chat room.',
        senderId : this.creatorId,
        isFromSystem : true
      };

      const createRoomRecent = {
        date : createDate,
        message : ' created the chat room.',
        sender : {
          id : this.creatorId,
          username : this.costumizedUsersData.username
        }
       
      };


      
      const createRoomMessageId = firebase.database().ref().child('chatMessages').push().key;

      firebase.database().ref('chatMessages/' + createRoomMessageId).set(createRoomMessage, (error) => {
        if (error) {
            this.$emit('notification','danger','There was an error creating chat room. Please try again.')

        } else {

          const newChatRoomId = firebase.database().ref().child('chatRooms').push().key;
          const newChatRoom = {
            creatorId : this.newChatRoom.creatorId.value,
            icon : this.newChatRoom.icon.value,
            name : this.newChatRoom.name.value,
            nameSearch : this.newChatRoom.name.value.toLowerCase(),
            description : this.newChatRoom.description.value,
            messagesIds : {},
            membersId : {},
            recent : createRoomRecent
          };

          newChatRoom.messagesIds[createRoomMessageId] = createDate;
          newChatRoom.membersId[this.creatorId] = true;

          //create the chat room
          firebase.database().ref('chatRooms').child(newChatRoomId).set(newChatRoom).then(() => {
            this.setDefaultChatRoomForm();
            //add the chatroom to the user
            firebase.database().ref('users').child(this.creatorId).child('chatRoomsId').child(newChatRoomId).set(Date.now()).then( ()=> {
              this.isCreatingChatRoom = false;
              this.isTabOpen = false;
              this.$emit('notification','success','Chat room created successfully.')
            });
            
          });
        }
      });
    }
  },
  watch : {
    chatRoomNameValue() {
      if(this.isCreatingChatRoom)return;
      this.validateNewChatRoom('name')
    },
    chatRoomIconValue () {
      if(this.isCreatingChatRoom)return;
      this.validateNewChatRoom('icon')
    },

  }

}
</script>

<style>

</style>